<template>
  <footer class="footer">
    <base-nav class="navbar-main" type="default" effect="dark" expand>
      <router-link slot="brand" to="/" class="navbar-brand mr-lg-5">
        <img src="img/ff/App Icon 2.png" alt="logo">
      </router-link>
      <div class="row" slot="content-header" slot-scope="{closeMenu}">
        <div class="col-6 collapse-brand">
          <router-link to="/">
            <img src="img/ff/App Icon 2.png" alt="logo">
          </router-link>
        </div>
        <div class="col-6 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>
      <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
        <li tag="li" class="nav-item text-uppercase">
          <router-link slot="title" to="/retirement" class="nav-link" data-toggle="dropdown" role="button">
            <i class="ni ni-collection d-lg-none"></i>
            <span class="nav-link-inner--text">Retirement</span>
          </router-link>
        </li>
        <li tag="li" class="nav-item text-uppercase">
          <router-link slot="title" to="/insurance" class="nav-link" data-toggle="dropdown" role="button">
            <i class="ni ni-collection d-lg-none"></i>
            <span class="nav-link-inner--text">Insurance</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link slot="title" to="/about" class="nav-link" data-toggle="dropdown" role="button">
            <i class="ni ni-collection d-lg-none"></i>
            <span class="nav-link-inner--text text-uppercase">About Us</span>
          </router-link>
        </li>
      </ul>
      <ul class="navbar-nav align-items-lg-center ml-lg-auto">
        <li class="nav-item">
          <a class="nav-link nav-link-icon" href="https://www.facebook.com/forwardfinancial" target="_blank" rel="noopener" data-toggle="tooltip" title="Like us on Facebook">
            <i class="fa fa-facebook-square"></i>
            <span class="nav-link-inner--text d-lg-none">Facebook</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link nav-link-icon" href="https://www.instagram.com/forwardfi" target="_blank" rel="noopener" data-toggle="tooltip" title="Follow us on Instagram">
            <i class="fa fa-instagram"></i>
            <span class="nav-link-inner--text d-lg-none">Instagram</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link nav-link-icon" href="https://www.youtube.com/channel/UCbr6IwbzWfWRo2TPsf2OgOQ" target="_blank" rel="noopener" data-toggle="tooltip" title="Follow us on Instagram">
            <i class="fa fa-youtube"></i>
            <span class="nav-link-inner--text d-lg-none">YouTube</span>
          </a>
        </li>
        <li class="nav-item d-none d-lg-block ml-lg-4">
          <router-link to="/contact" rel="noopener" class="btn btn-secondary btn-icon" role="button">
            <span class="btn-inner--icon">
                <i class="fa fa-cloud-download mr-2 text-default"></i>
            </span>
            <span class="nav-link-inner--text text-default">Contact</span>
          </router-link>
        </li>
      </ul>
    </base-nav>
  </footer>
</template>

<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";
export default {
  name: 'app-footer',
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown
  }
}
</script>

<style>
</style>
